<script setup lang="ts">
import { computed } from 'vue'
import { useDesignStore } from '../../store/useDesignStore'

const store = useDesignStore()
const items = computed(() => store.warnings)
const blocks = computed(() => items.value.filter((w) => w.severity === 'block'))
const warns = computed(() => items.value.filter((w) => w.severity === 'warn'))
</script>

<template>
  <div v-if="items.length" class="wb" :class="{ 'wb--block': blocks.length }" role="status">
    <template v-if="blocks.length">
      <strong>Noch nicht bestellbar:</strong>
      <button v-for="w in blocks" :key="w.code + (w.layerId || '')" type="button" class="wb__item" @click="w.layerId && store.select([w.layerId])">⛔ {{ w.message }}</button>
    </template>
    <template v-if="warns.length">
      <button v-for="w in warns" :key="w.code + (w.layerId || '')" type="button" class="wb__item" @click="w.layerId && store.select([w.layerId])">⚠ {{ w.message }}</button>
    </template>
  </div>
</template>

<style scoped>
.wb { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 12px; padding: 6px 12px; font-size: 12px; background: #fff7e6; border-top: 1px solid #f5c76b; }
.wb--block { background: #fdecea; border-top-color: #e30b17; }
.wb__item { border: 0; background: transparent; padding: 2px 0; font: inherit; cursor: pointer; text-align: left; }
.wb__item:hover { text-decoration: underline; }
</style>
